// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-text {
    letter-spacing: 1px;
    margin: 0px;
    font-family: 'Inter Regular';
    color: rgb(216, 115, 115);
    font-size: 14px;
}


.drawing-shape {
    margin-bottom: 15px;
}

.drawing-shape .matstrockview {
    margin: 0px 4px;
    border: 1px solid #003561;
    border-radius: 26.5805px;
    line-height: 20px;
    min-width: 52px;
    height: 40px !important;
}

.drawing-shape .matstrockview img {
    width: 20px;
    height: 20px;
    position: relative;
    top: 3.5px;

}

.matstrockview:active {
    background: #f1f8ff !important;
}

.active {
    background: #FFCC00;
    border: 1px solid #FFCC00 !important;
    color: #003561;
    border-radius: 26.5805px;
}

.mid-btn-y {
    position: relative;
    left: 65px;
}

@media (max-width: 768px) {

    .drawing-shape .matstrockview {
        min-width: 50px;
        margin: 0px 5px;
    }

}

.mat-tab-labels {
    display: flex;
    justify-content: center;
}

.mat-tab-label {
    padding: 10px 20px;
    background-color: #f0f0f0;
    cursor: pointer;
    border: 1px solid #ccc;
}

.mat-tab-label.mat-tab-label-active {
    background-color: lightgray;
}

:host ::ng-deep.mat-tab-label-active {
    color: #003561 !important;
    font-weight: 800 !important;
    font-family: 'Inter Regular';
}
`, "",{"version":3,"sources":["webpack://./projects/lib-map-common/src/lib/lasso-tool/lasso-tools.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;AACnB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI;QACI,eAAe;QACf,eAAe;IACnB;;AAEJ;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;AAChC","sourcesContent":[".info-text {\n    letter-spacing: 1px;\n    margin: 0px;\n    font-family: 'Inter Regular';\n    color: rgb(216, 115, 115);\n    font-size: 14px;\n}\n\n\n.drawing-shape {\n    margin-bottom: 15px;\n}\n\n.drawing-shape .matstrockview {\n    margin: 0px 4px;\n    border: 1px solid #003561;\n    border-radius: 26.5805px;\n    line-height: 20px;\n    min-width: 52px;\n    height: 40px !important;\n}\n\n.drawing-shape .matstrockview img {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    top: 3.5px;\n\n}\n\n.matstrockview:active {\n    background: #f1f8ff !important;\n}\n\n.active {\n    background: #FFCC00;\n    border: 1px solid #FFCC00 !important;\n    color: #003561;\n    border-radius: 26.5805px;\n}\n\n.mid-btn-y {\n    position: relative;\n    left: 65px;\n}\n\n@media (max-width: 768px) {\n\n    .drawing-shape .matstrockview {\n        min-width: 50px;\n        margin: 0px 5px;\n    }\n\n}\n\n.mat-tab-labels {\n    display: flex;\n    justify-content: center;\n}\n\n.mat-tab-label {\n    padding: 10px 20px;\n    background-color: #f0f0f0;\n    cursor: pointer;\n    border: 1px solid #ccc;\n}\n\n.mat-tab-label.mat-tab-label-active {\n    background-color: lightgray;\n}\n\n:host ::ng-deep.mat-tab-label-active {\n    color: #003561 !important;\n    font-weight: 800 !important;\n    font-family: 'Inter Regular';\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
